import * as React from "react";
import {TypeInput} from "../../../type/TypeInput";
import type {IInputProps} from "../../FieldInput";

export class TypeInlineInput extends React.Component<IInputProps> {
	public override render() {
		return <TypeInput {...this.props} />;
	}
}
